import Backbone from 'backbone';
import $ from 'jquery';

import {ArchiveRecord} from 'archive/ArchiveConstants';
import {ResultsFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import {Permissions} from 'auth/PermissionConstants';
import * as statusbar from 'components/StatusBar';
import FileState, {FileStateAttributes} from 'filestate/FileState';
import {getStore} from 'redux-stores/Store';
import {shouldDisablePrimaryLinkColumn} from 'runs/shouldDisablePrimaryLinkColumn';
import * as GridUIReduxActions from 'samples/GridUIReduxActions';
import EntityStore from 'stores/EntityStore';

import * as GridDAO from '../GridDAO';
import * as StorableActions from '../StorableActions';
import StorableStore from '../StorableStore';

class GridToolbarState extends Backbone.Model {}

export default class GridFileState extends FileState {
  static openFile: (fileId: string) => JQueryPromise<unknown>;

  defaults(): FileStateAttributes {
    return {
      ...super.defaults(),
      toolbar: new GridToolbarState(),
      statusbar: new statusbar.GridStatusBarState(),
    };
  }

  initialize(...args: Array<unknown>): void {
    // @ts-expect-error
    super.initialize(...args);
    getStore().dispatch(GridUIReduxActions.openGrid(this.id));
  }

  editURL(): string {
    return GridDAO.gridEditorURL(this.id);
  }

  name(): string {
    return this.get('name') || 'Loading...';
  }

  archiveRecord(): ArchiveRecord | null {
    return this.get('archiveRecord');
  }

  setArchiveRecord(archiveRecord: ArchiveRecord | null): void {
    this.set({archiveRecord});
  }

  permissions(): Permissions {
    return this.get('permissions');
  }

  setPermissions(permissions: Permissions): void {
    this.set({permissions});
  }

  registerTitleAndURLSync(): void {
    this.on('change:name', () => {
      this.syncTitleAndURL();
    });
  }

  changeListener(): void {
    const grid = StorableStore.getGrid(this.id);
    if (grid) {
      this.set({name: grid.name, archiveRecord: grid.archiveRecord});
    }
  }

  registerListeners(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    StorableStore.addChangeListener(this.changeListener);
  }

  cleanUp(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    StorableStore.removeChangeListener(this.changeListener);
    StorableActions.closeGrid(this.id);
    getStore().dispatch(GridUIReduxActions.closeGrid(this.id));
  }

  hasResults(): boolean {
    return (
      isFeatureEnabled({feature: ResultsFeature.RESULTS_SHOW_DETAILS, item: {id: this.id}}) &&
      shouldDisablePrimaryLinkColumn() &&
      EntityStore.currentUser()
    );
  }
}

GridFileState.openFile = (fileId: string) =>
  $.Deferred()
    .resolve(new GridFileState({id: fileId}))
    .promise();
